import React from "react";
import "./Button.css";

interface ButtonProps {
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "dark" | "ghost";
  className?: string;
  onClick?: () => void;
  href?: string;
  type?: "button" | "submit" | "reset";
  target?: any;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = "primary",
  className = "",
  onClick,
  href,
  type = "button",
  target,
}) => {
  const classes = `btn btn-${variant} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes} target={target}>
        {children}
        <span className="arrow">→</span>
      </a>
    );
  }

  return (
    <button type={type} className={classes} onClick={onClick}>
      {children}
      <span className="arrow">→</span>
    </button>
  );
};

export default Button;
